import { useState, useEffect } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  PopoverArrow
} from "@/components/ui/popover";
import { workspaceAPI } from '../lib/api';

export default function MemberTasksPopover({ userId, workspaceId, handleTaskClick, children }) {
  const [open, setOpen] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);



  const fetchTasks = async () => {
    setLoading(true);
    try {
      const response = await workspaceAPI.getNotStartedTasks(workspaceId, userId);
      setTasks(response.data);
    } catch (error) {
      console.error('Failed to fetch tasks:', error);
      setError('Failed to fetch tasks');
    }
    finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (open && userId && workspaceId) {
      fetchTasks();
    }else{
      setTasks([]);
    }
  }, [open, userId, workspaceId]);

  const EnableDetailTask = () => {
    if(handleTaskClick === undefined) return false;
    return true;
  }

  const handleDetailTask = (task) => {
    if(!task || handleTaskClick === undefined ) return;
    handleTaskClick(task);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      {/* Trigger manual dari children */}
      <PopoverTrigger>
        {typeof children === "function"
          ? children({ open, setOpen })
          : children}
      </PopoverTrigger>

      <PopoverContent  side="top" align="center" className="w-[calc(95vw-2rem)] md:w-96" >
        <div className="space-y-2">
          <h4 className="font-semibold text-sm pb-1 mb-2 text-brand-primary border-b border-brand-border">
            To-do Tasks ({tasks?.length || 0})
          </h4>
          {loading && <p className="text-sm text-muted-foreground">Loading...</p>}
          {error && <p className="text-sm text-red-500">{error}</p>}
          {!loading && !error && tasks.length === 0 && (
            <p className="text-sm text-muted-foreground">No tasks available</p>
          )}
          {!loading && !error && tasks.length > 0 && (
            <ul className="list-disc list-outside space-y-3 mb-3 pl-6">
              {tasks.map((task, index) => (
                <li key={index} className={`text-sm break-words ${ EnableDetailTask() ? "cursor-pointer hover:text-brand-primary" : "" } `} onClick={() => handleDetailTask(task)} title={task.title}>
                  <div className="space-y-1">
                    <p className="line-clamp-1">
                      <span className="" >
                        {`[${task.task_code}] `}
                      </span>
                      <span>
                        {task.title}
                      </span>
                    </p>
                    {task.due_date && (
                      <p className="text-xs text-gray-500 flex items-center gap-1">
                        <span>📅</span>
                        <span>Due: {new Date(task.due_date).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <PopoverArrow />
      </PopoverContent>
    </Popover>
  );
}